import { useQuery } from "@tanstack/react-query";

interface PreviewGateStatus {
  enabled: boolean;
  passed: boolean;
}

export function usePreviewGate() {
  const { data, isLoading, error } = useQuery<PreviewGateStatus>({
    queryKey: ["/api/preview-gate/status"],
    staleTime: 1000 * 60, // 1 minute
  });

  return {
    isLoading,
    error,
    isEnabled: data?.enabled ?? false,
    hasPassed: data?.passed ?? false,
    needsGate: data?.enabled && !data?.passed,
  };
}
